module.exports = __webpack_public_path__ + "img/file1.6ac5d030.png";